/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountControllerDtoAccountPunishStatusUpdateRequest model module.
 * @module model/AccountControllerDtoAccountPunishStatusUpdateRequest
 * @version 1.0
 */
class AccountControllerDtoAccountPunishStatusUpdateRequest {
    /**
     * Constructs a new <code>AccountControllerDtoAccountPunishStatusUpdateRequest</code>.
     * @alias module:model/AccountControllerDtoAccountPunishStatusUpdateRequest
     * @param accountNo {Number} 
     * @param reasonSort {Number} 
     */
    constructor(accountNo, reasonSort) { 
        
        AccountControllerDtoAccountPunishStatusUpdateRequest.initialize(this, accountNo, reasonSort);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, accountNo, reasonSort) { 
        obj['accountNo'] = accountNo;
        obj['reasonSort'] = reasonSort;
    }

    /**
     * Constructs a <code>AccountControllerDtoAccountPunishStatusUpdateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountControllerDtoAccountPunishStatusUpdateRequest} obj Optional instance to populate.
     * @return {module:model/AccountControllerDtoAccountPunishStatusUpdateRequest} The populated <code>AccountControllerDtoAccountPunishStatusUpdateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountControllerDtoAccountPunishStatusUpdateRequest();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('reasonSort')) {
                obj['reasonSort'] = ApiClient.convertToType(data['reasonSort'], 'Number');
            }
            if (data.hasOwnProperty('period')) {
                obj['period'] = ApiClient.convertToType(data['period'], 'Number');
            }
            if (data.hasOwnProperty('reason')) {
                obj['reason'] = ApiClient.convertToType(data['reason'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountControllerDtoAccountPunishStatusUpdateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountControllerDtoAccountPunishStatusUpdateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of AccountControllerDtoAccountPunishStatusUpdateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['reason'] && !(typeof data['reason'] === 'string' || data['reason'] instanceof String)) {
            throw new Error("Expected the field `reason` to be a primitive type in the JSON string but got " + data['reason']);
        }

        return true;
    }


}

AccountControllerDtoAccountPunishStatusUpdateRequest.RequiredProperties = ["accountNo", "reasonSort"];

/**
 * @member {Number} accountNo
 */
AccountControllerDtoAccountPunishStatusUpdateRequest.prototype['accountNo'] = undefined;

/**
 * @member {Number} reasonSort
 */
AccountControllerDtoAccountPunishStatusUpdateRequest.prototype['reasonSort'] = undefined;

/**
 * @member {Number} period
 */
AccountControllerDtoAccountPunishStatusUpdateRequest.prototype['period'] = undefined;

/**
 * @member {String} reason
 */
AccountControllerDtoAccountPunishStatusUpdateRequest.prototype['reason'] = undefined;






export default AccountControllerDtoAccountPunishStatusUpdateRequest;

